import { Type } from 'class-transformer';

export class Coordinates {
  lat: number;
  lng: number;
}

export type AddressType = 'billing' | 'shipping' | 'other';

export class Address {
  city: string | null;

  @Type(() => Coordinates)
  coordinates: Coordinates | null;

  country: string | null;

  description: string | null;

  email: string | null;

  latitude: number | null;

  line1: string | null;

  line2: string | null;

  longitude: number | null;

  name: string;

  phone: string | null;

  postal_code: string | null;

  state: string | null;

  type: AddressType;

  isEmpty() {
    return !Boolean(this.country || this.city || this.state || this.line1);
  }

  format(): string {
    return [this.line1, this.line2, this.formatCityState()].filter((v) => Boolean(v)).join('\n');
  }

  formatCityState(): string {
    let formattedCity = this.city || '';
    if (this.state) {
      if (formattedCity) formattedCity += ', ';
      formattedCity += this.state + ' ';
    }

    if (this.postal_code) {
      formattedCity += this.postal_code + ' ';
    }

    if (this.country && this.country !== 'US') {
      formattedCity += this.country + ' ';
    }

    return formattedCity.trim();
  }
}
